import { createContext,useContext,useState,useEffect } from 'react';
import { toast } from 'sonner';
const Store=createContext(null);
function readCart(){try{return JSON.parse(localStorage.getItem('mt-basket')||'[]');}catch{return [];}}
export function StoreProvider({children}){
  const [cart,setCart]=useState(readCart);
  useEffect(()=>{localStorage.setItem('mt-basket',JSON.stringify(cart));},[cart]);
  const add=(selection,service)=>{setCart(old=>[...old,{key:crypto.randomUUID(),selection,service}]);toast.success('Service added to your basket');};
  const remove=key=>setCart(old=>old.filter(x=>x.key!==key));
  const update=(key,selection,service)=>{setCart(old=>old.map(x=>x.key===key?{key,selection,service}:x));toast.success('Service scope updated');};
  return <Store.Provider value={{cart,add,remove,update,clear:()=>setCart([])}}>{children}</Store.Provider>;
}
export const useStore=()=>useContext(Store);